import React from 'react';
import useGetGameStoreStatsInfo from '@/pages/opinion/widgets/GameStorePlate/hooks/useGetGameStoreStatsInfo';
import useGetGameStoreTimelineInfo from '@/pages/opinion/widgets/GameStorePlate/hooks/useGetGameStoreTimelineInfo';
import { GameStoreMobileChart } from '@/pages/opinion/widgets/GameStorePlate/components/GameStoreMobileChart';
import { useIntl } from 'umi';
import { XboxGameStore } from '@/pages/opinion/widgets/GameStorePlate/components/XboxGameStore';
import { formatDateFunc } from '@/pages/opinion/utils/time';
import CardCommon from '@/pages/opinion/components/CardCommon';
import { Col, Justify, Row } from 'tea-component';
import CardLoading from '@/pages/opinion/components/CardLoading';
import {
  FilterFixed,
  useFilterDataHook,
} from '@/pages/opinion/components/FilterCommon';
import useFeedsDetail from '../../hooks/useFeedsDetail';

const channel = 'playstation';
export default function PlaystationStore({ gameInfo, scrollBody }: any) {
  const { formatMessage } = useIntl();

  const {
    loading: initLoading,
    filter,
    changeFilter,
    filterOptions,
  } = useFilterDataHook({
    gameInfo,
    hasHero: true,
    pageName: 'GameStore_Playstation',
  });

  const {
    loading: statsLoading,
    ratingInfo,
    ratings,
  } = useGetGameStoreStatsInfo({
    gameInfo,
    filter,
    type: channel,
    lifetimeTitle: 'Lifetime Rating',
  });

  const { trendLoading: psLoading, mobileTrendsInfo: psTrendsInfo } =
    useGetGameStoreTimelineInfo({ gameInfo, filter, type: channel });
  const formatTime = formatDateFunc(filter?.date_type);
  const { feedsBtnElement } = useFeedsDetail({ filter, channel });
  const columns = [
    {
      key: 'type',
      header: formatMessage({ id: 'Rating' }),
    },
    {
      weight: 'bold',
      align: 'right',
      key: 'score',
      header: formatMessage({ id: 'Ratings' }),
    },
    {
      weight: 'bold',
      align: 'right',
      key: 'percentage',
      header: formatMessage({ id: 'Share-1' }),
    },
  ];
  return (
    <>
      <FilterFixed
        filter={filterOptions}
        scrollBody={scrollBody}
        confirm={(value: any) => {
          changeFilter({
            ...value,
            ...gameInfo,
            channel: [channel],
            channel_type: 'comments',
          });
        }}
        defaultConfig={{ region: { showTips: false } }}
        operateShowOptions={['history', 'more']}
      ></FilterFixed>
      <Justify right={feedsBtnElement}></Justify>
      <CardLoading loading={initLoading}>
        <div>
          {ratings.map(({ ratingKey, time, title }) => {
            const isLifetime = ratingKey === 'lifetime';
            const realTime = isLifetime ? formatTime(time) : time;
            if (!isLifetime) {
              return null;
            }
            return (
              <CardCommon key={ratingKey}>
                <Row gap={30}>
                  <Col span={12}>
                    <XboxGameStore
                      className="dbo-scorebox"
                      ratingKey={ratingKey}
                      key={ratingKey}
                      filter={filter}
                      time={realTime}
                      loading={statsLoading}
                      title={title}
                      height={238}
                      channel={channel}
                      ratingInfo={ratingInfo[ratingKey]}
                    ></XboxGameStore>
                  </Col>

                  <Col span={12}>
                    <GameStoreMobileChart
                      data={psTrendsInfo?.[ratingKey] || {}}
                      filter={filter}
                      // height={212}
                      loadingHeight={227}
                      hideLifetime={!isLifetime}
                      hideSelected={isLifetime}
                      isMin
                      loading={psLoading}
                      channel={channel}
                      formatMessage={formatMessage}
                      columns={columns}
                      leftTitle={'Ratings'}
                      rightTitle={'Rating'}
                      sumTitle={'Sum of Rating'}
                      lifetimeTitle={'Lifetime Rating'}
                    ></GameStoreMobileChart>
                  </Col>
                </Row>
              </CardCommon>
            );
          })}
        </div>
      </CardLoading>
    </>
  );
}
